import React from 'react';

import './style.scss';

import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';


const Share = ({ title = 'Deel deze pagina', pageTitle = '' }) => {
  const url = window.location.href;
  return (
    <div className="Share">
      <div className="Share__wrapper">
        <h4 className="page-header">{title}</h4>
        <EmailShareButton body={pageTitle} url={url}>
          <div className="Share__item mail">
            <div className="icon icon-mail icon-variant-3" />
          </div>
        </EmailShareButton>

        <FacebookShareButton title={pageTitle} url={url}>
          <div className="Share__item facebook">
            <div className="icon icon-facebook icon-variant-3" />
          </div>
        </FacebookShareButton>

        <LinkedinShareButton title={pageTitle} url={url}>
          <div className="Share__item linkedin">
            <div className="icon icon-linkedin icon-variant-3" />
          </div>
        </LinkedinShareButton>

        <TwitterShareButton title={pageTitle} url={url}>
          <div className="Share__item x">
            <div className="icon icon-x icon-variant-3" />
          </div>
        </TwitterShareButton>


        <WhatsappShareButton title={pageTitle} url={url}>
          <div className="Share__item whatsapp">
            <div className="icon icon-whatsapp icon-variant-3" />
          </div>
        </WhatsappShareButton>
      </div>
    </div>
  );
};

export default Share;
